import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import Pagination from 'components/Pagination';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import ListModal from './Components/ListModal';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import IgnoredWordsService from '../service';
import { TagFilas } from 'views/ChatConfiguration/modules/timeout/style';

const IgnoredWordsList = () => {
  const [ignoredWords, setIgnoredWords] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [idWordsList, setidWordsList] = useState();
  const [isListModalOpen, setIsListModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const getIgnoredWords = (selectedPage = 1, search = '') => {
    setLoading(true);
    IgnoredWordsService.getAllFilter(selectedPage, search)
      .then((res) => {
        const ignoredWords = res.data.data || [];
        const quantity = res.data.total || 0;

        setIgnoredWords(ignoredWords);
        setQuantity(quantity);
        setActivePage(selectedPage);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Erro ao carregar palavras ignoradas:', err);
        toast.error(
          err.response?.data?.message ||
            'Erro ao carregar as listas de palavras ignoradas!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    getIgnoredWords();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const timer = setTimeout(() => {
      setActivePage(1);
      getIgnoredWords(1, value);
    }, 500);

    return () => clearTimeout(timer);
  };

  const handlePageChange = (activePage) => {
    getIgnoredWords(activePage, searchTerm);
  };

  const deleteIgnoredWords = (id) => {
    IgnoredWordsService.delete(id)
      .then(() => {
        toast.success('Lista de palavras ignoradas deletada!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            'Erro ao deletar lista de palavras ignoradas!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getIgnoredWords(activePage, searchTerm);
      });
  };

  const controlDelete = (id) => {
    setOpenModalConfirmation(true);
    setidResource(id);
  };

  const canEditItem = (item) => {
    return item.id || item._id;
  };

  const handleDeleteSuccess = () => {
    getIgnoredWords(activePage, searchTerm);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/ignoredWords/form"
        name="Palavras Ignoradas"
        parentName="Configurações"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <Row className="align-items-center">
                    <Col md="6">
                      <h3 className="mb-0">Lista de Palavras Ignoradas</h3>
                    </Col>
                  </Row>
                  <Row className="align-items-center mt-3">
                    <Col md="12">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Buscar por título ou canal"
                          value={searchTerm}
                          onChange={handleSearch}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              setActivePage(1);
                              getIgnoredWords(1, searchTerm);
                            }
                          }}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardHeader>

                <ToolkitProvider
                  data={ignoredWords}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'title',
                      text: 'Título',
                      sort: true,
                      style: {
                        ...individual_column_style,
                        verticalAlign: 'middle'
                      },
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'channel',
                      text: 'Canais',
                      sort: true,
                      style: {
                        ...individual_column_style,
                        verticalAlign: 'middle'
                      },
                      headerStyle: individual_header_style,
                      formatter: (cell, row) => {
                        const channels = Array.isArray(cell)
                          ? cell
                          : row.channel && Array.isArray(row.channel)
                          ? row.channel
                          : [];

                        return (
                          <>
                            {channels.map((item, index) => (
                              <div key={index}>
                                <TagFilas>{item}</TagFilas>
                              </div>
                            ))}
                          </>
                        );
                      }
                    },
                    {
                      dataField: 'words',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Palavras',
                      formatter: (cell, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => {
                              const itemId = row.id || row._id;
                              if (itemId) {
                                setidWordsList(itemId);
                                setIsListModalOpen(true);
                              } else {
                                toast.error('ID da lista não encontrado!', {
                                  autoClose: 3000,
                                  closeOnClick: true
                                });
                              }
                            }}
                            title="Ver palavras"
                          >
                            <i className="fas fa-list" />
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: {
                        ...icon_column_style,
                        verticalAlign: 'middle'
                      },
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (cell, row) => {
                        const itemId = row.id || row._id;

                        if (!canEditItem(row)) {
                          return (
                            <Button
                              color="secondary"
                              size="sm"
                              disabled
                              title="Item não pode ser editado"
                            >
                              <i className="fas fa-user-edit"></i>
                            </Button>
                          );
                        }

                        return (
                          <Link to={`/admin/ignoredWords/form/${itemId}`}>
                            <Button color="info" size="sm" title="Editar item">
                              <i className="fas fa-user-edit"></i>
                            </Button>
                          </Link>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: {
                        ...icon_column_style,
                        verticalAlign: 'middle'
                      },
                      headerStyle: individual_icon_header_style,
                      text: 'Deletar',
                      formatter: (cell, row) => {
                        const itemId = row.id || row._id;

                        if (!canEditItem(row)) {
                          return (
                            <Button
                              color="secondary"
                              size="sm"
                              disabled
                              title="Item não pode ser deletado"
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          );
                        }

                        return (
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => controlDelete(itemId)}
                            title="Deletar item"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <>
                          {ignoredWords.length === 0 ? (
                            <div className="text-center py-4">
                              <p className="text-muted">
                                {searchTerm
                                  ? `Nenhuma lista encontrada para "${searchTerm}"`
                                  : 'Nenhuma lista de palavras ignoradas encontrada.'}
                              </p>
                            </div>
                          ) : (
                            <BootstrapTable
                              {...props.baseProps}
                              bootstrap4={true}
                              bordered={false}
                              classes="align-items-center table-flush"
                              noDataIndication="Nenhum dado encontrado"
                            />
                          )}
                        </>
                      )}
                    </div>
                  )}
                </ToolkitProvider>

                {quantity > 0 && (
                  <Pagination
                    activePage={activePage}
                    totalItemsCount={quantity}
                    onChange={handlePageChange}
                  />
                )}
              </Card>
            </div>
          </div>
        </Row>
      </Container>

      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteIgnoredWords}
        message={
          'Tem certeza que deseja excluir a lista de palavras ignoradas?'
        }
      />

      <ListModal
        isModalOpen={isListModalOpen}
        onModalToggle={setIsListModalOpen}
        ignoredWords={idWordsList}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </>
  );
};

export default IgnoredWordsList;
